import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductGalleryHighlights extends Component {
  #mobileMediaQuery = window.matchMedia('(max-width: 749px)');
  /** @type {HTMLElement | null} */
  #moveContainer = null;
  /** @type {Node | null} */
  #originalParent = null;
  /** @type {ChildNode | null} */
  #originalNextSibling = null;
  #isMoved = false;

  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;

    section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);

    const containerCandidate = this.closest('.media-gallery-with-highlights__highlights');
    this.#moveContainer = containerCandidate instanceof HTMLElement ? containerCandidate : this;
    this.#originalParent = this.#moveContainer.parentNode;
    this.#originalNextSibling = this.#moveContainer.nextSibling;

    this.#updateMobilePlacement();
    this.#mobileMediaQuery.addEventListener('change', this.#updateMobilePlacement);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;

    section.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#mobileMediaQuery.removeEventListener('change', this.#updateMobilePlacement);
    this.#restoreOriginalPlacement();
  }

  /**
   * @param {CustomEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const updated = event.detail.data.html.querySelector(
      `product-gallery-highlights[data-block-id="${this.dataset.blockId}"]`
    );

    if (!updated) return;
    morph(this, updated, { childrenOnly: true });
  };

  #updateMobilePlacement = () => {
    // Mobile order is now handled via CSS (flex-direction: column on .media-gallery-with-highlights).
  };

  #moveOnMobile() {
    if (this.#isMoved) return;

    const productInformation = this.closest('.product-information');
    if (!productInformation) return;

    const productDetails = productInformation.querySelector('[data-testid="product-information-details"]');
    if (!(productDetails instanceof HTMLElement) || !(this.#moveContainer instanceof HTMLElement)) return;

    const returnPolicyTextBlock = productDetails.querySelector('.text-block--align-center.type-meta');
    if (returnPolicyTextBlock instanceof HTMLElement) {
      returnPolicyTextBlock.insertAdjacentElement('beforebegin', this.#moveContainer);
      this.#moveContainer.classList.add('pgh-moved-before-footer-note');
    } else {
      productDetails.insertAdjacentElement('afterend', this.#moveContainer);
    }

    this.#moveContainer.classList.add('pgh-moved-after-details');
    this.#isMoved = true;
  }

  #restoreOriginalPlacement() {
    if (!(this.#moveContainer instanceof HTMLElement) || !this.#isMoved || this.#originalParent == null) return;

    if (this.#originalNextSibling && this.#originalNextSibling.parentNode === this.#originalParent) {
      this.#originalParent.insertBefore(this.#moveContainer, this.#originalNextSibling);
    } else {
      this.#originalParent.appendChild(this.#moveContainer);
    }

    this.#moveContainer.classList.remove('pgh-moved-before-footer-note');
    this.#moveContainer.classList.remove('pgh-moved-after-details');
    this.#isMoved = false;
  }
}

if (!customElements.get('product-gallery-highlights')) {
  customElements.define('product-gallery-highlights', ProductGalleryHighlights);
}
